import { useParams } from 'react-router-dom';
import { useBookings } from '../../shared/booking/BookingsContext';
import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { insuranceRefund } from './data';
import InsuranceSummary from './InsuranceSummary';
import InsurancePolicies from './InsurancePolicies';

export default function InsuranceBookingDetails() {
  const { bookingId } = useParams();
  const { getBooking } = useBookings();
  const booking = getBooking(bookingId);
  // Live policies are cancelled with the insurer from the policies panel, per traveller.
  const live = Boolean(booking?.supplierBookingId);

  return (
    <BookingDetailsPage
      module="insurance"
      Summary={InsuranceSummary}
      refLabel="Policy number"
      refund={insuranceRefund}
      allowCancel={!live}
      extraDetails={live && <InsurancePolicies booking={booking} allowCancel />}
      policy={live ? [
        'Policies can be cancelled online up to 24 hours before cover starts, for one or all travellers.',
        'The premium is refunded to your original payment method; the convenience fee is not refunded.',
        'Once cover has started, the policy cannot be cancelled.',
        'For claims, call the 24x7 assistance number on your policy document.',
      ] : [
        'Policies can be cancelled for a full refund (minus ₹100) before the policy start date.',
        'Once the policy period begins, it cannot be cancelled online.',
      ]}
    />
  );
}
